import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { liveCodingStatus } from 'constants/tests';
import { buttonIds } from '../../FreecodeLayout/FreecodeLayoutConstants';
import { FreecodeButton } from 'components/Button/RectangleButton';

export default function LiveCodingStatus() {
  const { ticketId } = useParams();

  let candidateCodeStatusTimerId = useRef(null);

  const [candidateCodeStatus, setCandidateCodeStatus] = useState(liveCodingStatus.IDLE);

  let { ticketCodeData, isCodeRunning } = useSelector((state) => state.freecode);

  useEffect(() => {
    if (ticketCodeData[ticketId]?.code) setCandidateCodeStatus(liveCodingStatus.TYPING);
    clearTimeout(candidateCodeStatusTimerId.current);
    candidateCodeStatusTimerId.current = setTimeout(() => {
      setCandidateCodeStatus(liveCodingStatus.IDLE);
    }, 2000);
  }, [ticketCodeData, ticketId]);

  useEffect(() => {
    if (isCodeRunning[ticketId]) setCandidateCodeStatus(liveCodingStatus.RUNNING);
    else setCandidateCodeStatus(liveCodingStatus.IDLE);
  }, [isCodeRunning, ticketId]);

  return (
    <FreecodeButton id={buttonIds.liveCodingStatusButton} small disabled>
      Status: {candidateCodeStatus}
    </FreecodeButton>
  );
}
